import { getLocalStorage, saveLocalStorage } from './webCache'

const colorArr = [
  'd50000',
  'ff1744',
  'd32f2f',
  'f44336',
  'f50057',
  'e91e63',
  'd500f9',
  '651fff',
  '7c4dff',
  '3d5afe',
  '2979ff',
  '1e88e5',
  '00b0ff',
  '00e5ff',
  '1de9b6',
  '26a69a',
  '00e676',
  '76ff03',
  'c6ff00',
  'ffea00',
  'ffeb3b',
  'ffc400',
  'ff6d00',
  'f4511e',
  'cf1322',
  'ba68c8',
  '9575cd',
  '9575cd',
  '3d5afe'
]

if (!getLocalStorage('nickNameColor')) {
  const randomNumber = Math.ceil(Math.random() * 28)

  const nickNameColor = '#' + colorArr[randomNumber]

  saveLocalStorage('nickNameColor', nickNameColor)
}



// WEBPACK FOOTER //
// ./src/utils/randomNicknameColour.js